module.exports = __webpack_public_path__ + "static/logo-light2-7a7a15238857993a0106d3320399093a.png";